import { MobileSizeService } from './../services/mobile-size.service';
import { MenuItem } from 'primeng/api';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { LayoutComponent } from './layout.component';

// @Component({
//   selector: 'app-menu',
//   templateUrl: './app.menu.html'
// })
@Component({
  selector: 'app-menu',
  template: `
        <div class="layout-menu-container" (click)="app.onMenuClick($event)">
            <div class="overlay-menu-button" (click)="app.onMenuButtonClick($event)">
                <div class="overlay-menu-button-bars">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="overlay-menu-button-times">
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div class="layout-menu-wrapper fadeInDown">
            <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
                <!-- [reset]="reset" -->
            </div>
        </div>
    `
})
export class AppMenuComponent implements OnInit, OnDestroy {

  model: any[];
  userSub: Subscription;

  // @HostListener('window:resize', [])
  // public onResize() {
  //   if (window.innerWidth < 991) {
  //     if (!this.mobileSizeService.mobileWidthBS.value) { // only change if have to
  //       this.mobileSizeService.mobileWidthBS.next(true);
  //     }
  //   } else {
  //     if (this.mobileSizeService.mobileWidthBS.value) { // only change if have to
  //       this.mobileSizeService.mobileWidthBS.next(false);
  //     }
  //   }

  // }


  constructor(
    public app: LayoutComponent,
    private authService: AuthService,
    private mobileSizeService: MobileSizeService
  ) { }

  ngOnInit() {
    // if (window.innerWidth < 991) {
    //   if (!this.mobileSizeService.mobileWidthBS.value) { // only change if have to
    //     this.mobileSizeService.mobileWidthBS.next(true);
    //   }
    // } else {
    //   if (this.mobileSizeService.mobileWidthBS.value) { // only change if have to
    //     this.mobileSizeService.mobileWidthBS.next(false);
    //   }
    // }

    // const userMenu: MenuItem[] = [
    //   { label: 'Dashboard', icon: 'pi pi-chart-bar', routerLink: ['/dashboard'], },
    //   {
    //     label: 'Supplies', icon: 'supplies-icon', routerLink: ['/supplies'], items: [
    //       { label: 'Supplies', icon: 'pi supplies-icon-black', routerLink: ['/supplies'] },
    //       { label: 'Orders', icon: 'pi orders-icon-black', routerLink: ['/supplies/orders'] },
    //       { label: 'Supplier', icon: 'suppliers-icon-black', routerLink: ['/supplies/suppliers'] },
    //     ]
    //   },

    //   { label: 'Usage', icon: 'usages-icon', routerLink: ['/usages'], },
    //   { label: 'Output', icon: 'outputs-icon', routerLink: ['/outputs'], },
    //   tslint:disable-next-line:max-line-length
    //   { label: 'Settings', icon: 'setting-icon', routerLink: ['/settings']}
    // ];

    // const admin: MenuItem[] = [
    //   { label: 'Notifications', icon: 'pi pi-envelope', routerLink: ['/notifications'], },
    //   {
    //     label: 'Admin', icon: 'setting-icon', routerLink: ['/admin'] , items: [
    //       { label: 'Users', icon: 'pi pi-users', routerLink: ['/admin/users'] },
    //       { label: 'Master Supplies', icon: 'pi supplies-icon-black', routerLink: ['/admin/mastersupplies'], },
    //       { label: 'Master Care Provider', icon: 'pi pi-fw pi-home', routerLink: ['/admin/mastercareprovider'], },
    //       { label: 'Push Notifications', icon: 'pi pi-envelope', routerLink: ['/admin/pushnotifications'] },
    //       { label: 'Bulk Emails', icon: 'pi pi-envelope', routerLink: ['/admin/bulk-emails'] },
    //       { label: 'Push Topics', icon: 'terms-use-black', routerLink: ['/admin/pushtopics'] },
    //       { label: 'Release Notes', icon: 'terms-use-black', routerLink: ['/admin/release-notes'] },
    //       { label: 'App Settings', icon: 'pi pi-cog', routerLink: ['/admin/mastersettings'] },
    //       { label: 'Sponsors', icon: 'pi pi-cog', routerLink: ['/admin/sponsors'] },
    //     ]
    //   }
    // ];


    // const combine = combineLatest([this.authService.userDetailsObs, this.mobileSizeService.mobileWidthBS]);
    // this.userSub = combine
    //   .subscribe(([user, mobile]) => {
    //     this.model = [...userMenu];
    //     if (user.role === 0) { // Admin
    //       this.model.push(...admin);
    //     }
    //     const len = this.model.length - 1;
    //     console.log(mobile);
    //     if (mobile) {
    //         this.model.push({
    //           label: 'Sign out', command: () => this.onLogout()
    //         });
    //     }
    //   });

  }


  onLogout() {
    // this.app.onTopbarSubItemClick(event);
    this.authService.logout();
  }

  ngOnDestroy() {
    this.userSub.unsubscribe();
  }
}
